export * from './common';
let NftServices = null;
export const configureNftServices = (services) => {
    NftServices = services;
};
export { NftServices };
export const CATEGORIES = [];
